// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.is-sticky {
  width: 100%;
  position: fixed;
  top: 0px;
  z-index: 999;
}

.container {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.is-static {
  width: 100%;
  position: sticky;
  top: 0px;
  z-index: 999;
}

:host ::ng-deep .navbar-dark .navbar-nav .nav-link {
  color: white !important;
}

:host ::ng-deep .navbar-light .navbar-nav .nav-link {
  color: #6b6f82 !important;
}

.dropdown-menu .dropdown-submenu>a:after {
  top: 14px;
}

.dropdown .dropdown-menu {
  min-width: 13rem !important;
}

.navbar-horizontal .dropdown-menu .dropdown-submenu>a:after,
.navbar-horizontal .dropdown-menu .dropdown-submenu>button:after {
  right: 0.5rem;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImhvcml6b250YWxuYXYuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFdBQVc7RUFDWCxlQUFlO0VBQ2YsUUFBUTtFQUNSLFlBQVk7QUFDZDs7QUFFQTtFQUNFLDRCQUE0QjtFQUM1Qiw2QkFBNkI7QUFDL0I7O0FBRUE7RUFDRSxXQUFXO0VBQ1gsZ0JBQWdCO0VBQ2hCLFFBQVE7RUFDUixZQUFZO0FBQ2Q7O0FBRUE7RUFDRSx1QkFBdUI7QUFDekI7O0FBRUE7RUFDRSx5QkFBeUI7QUFDM0I7O0FBRUE7RUFDRSxTQUFTO0FBQ1g7O0FBRUE7RUFDRSwyQkFBMkI7QUFDN0I7O0FBRUE7O0VBRUUsYUFBYTtBQUNmIiwiZmlsZSI6Imhvcml6b250YWxuYXYuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5pcy1zdGlja3kge1xuICB3aWR0aDogMTAwJTtcbiAgcG9zaXRpb246IGZpeGVkO1xuICB0b3A6IDBweDtcbiAgei1pbmRleDogOTk5O1xufVxuXG4uY29udGFpbmVyIHtcbiAgcGFkZGluZy1sZWZ0OiAwcHggIWltcG9ydGFudDtcbiAgcGFkZGluZy1yaWdodDogMHB4ICFpbXBvcnRhbnQ7XG59XG5cbi5pcy1zdGF0aWMge1xuICB3aWR0aDogMTAwJTtcbiAgcG9zaXRpb246IHN0aWNreTtcbiAgdG9wOiAwcHg7XG4gIHotaW5kZXg6IDk5OTtcbn1cblxuOmhvc3QgOjpuZy1kZWVwIC5uYXZiYXItZGFyayAubmF2YmFyLW5hdiAubmF2LWxpbmsge1xuICBjb2xvcjogd2hpdGUgIWltcG9ydGFudDtcbn1cblxuOmhvc3QgOjpuZy1kZWVwIC5uYXZiYXItbGlnaHQgLm5hdmJhci1uYXYgLm5hdi1saW5rIHtcbiAgY29sb3I6ICM2YjZmODIgIWltcG9ydGFudDtcbn1cblxuLmRyb3Bkb3duLW1lbnUgLmRyb3Bkb3duLXN1Ym1lbnU+YTphZnRlciB7XG4gIHRvcDogMTRweDtcbn1cblxuLmRyb3Bkb3duIC5kcm9wZG93bi1tZW51IHtcbiAgbWluLXdpZHRoOiAxM3JlbSAhaW1wb3J0YW50O1xufVxuXG4ubmF2YmFyLWhvcml6b250YWwgLmRyb3Bkb3duLW1lbnUgLmRyb3Bkb3duLXN1Ym1lbnU+YTphZnRlcixcbi5uYXZiYXItaG9yaXpvbnRhbCAuZHJvcGRvd24tbWVudSAuZHJvcGRvd24tc3VibWVudT5idXR0b246YWZ0ZXIge1xuICByaWdodDogMC41cmVtO1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/_layout/navigation/horizontalnav/horizontalnav.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;AACf;;AAEA,w/CAAw/C","sourcesContent":[".is-sticky {\n  width: 100%;\n  position: fixed;\n  top: 0px;\n  z-index: 999;\n}\n\n.container {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n\n.is-static {\n  width: 100%;\n  position: sticky;\n  top: 0px;\n  z-index: 999;\n}\n\n:host ::ng-deep .navbar-dark .navbar-nav .nav-link {\n  color: white !important;\n}\n\n:host ::ng-deep .navbar-light .navbar-nav .nav-link {\n  color: #6b6f82 !important;\n}\n\n.dropdown-menu .dropdown-submenu>a:after {\n  top: 14px;\n}\n\n.dropdown .dropdown-menu {\n  min-width: 13rem !important;\n}\n\n.navbar-horizontal .dropdown-menu .dropdown-submenu>a:after,\n.navbar-horizontal .dropdown-menu .dropdown-submenu>button:after {\n  right: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
